import ko from '@tko/build.knockout';
import templateMarkup from 'raw-loader!./footer-comp.html';
import moment from 'moment-timezone';
import BrandingService from '../../services/branding.service';

function FooterComp(params) {
    this.message = ko.observable('Hello from the footer-comp component!');

    var self = this;
    self.brandingService = BrandingService;
    self.currentYear = moment().year();
}

// This runs when the component is torn down. Put here any logic necessary to clean up,
// for example cancelling setTimeouts or disposing Knockout subscriptions/computeds.
FooterComp.prototype.dispose = function() { };

export default { viewModel: FooterComp, template: templateMarkup };
